import React, { useState, useEffect } from "react";
import { array, string, object } from "prop-types";
import get from "lodash/get";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";
import DfpAd from "../../../dfp-ad";

import "./row1.m.css";

const Row1 = ({ stories, collectionSlug, publisherAttributes, adSlotId = "" }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [firstStory] = stories;
  let heroImage = "";
  if (get(stories[0].story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"])) {
    heroImage = stories[0].story.alternative.home.default["hero-image"]["hero-image-s3-key"];
  } else if (stories[0].story["hero-image-s3-key"]) {
    heroImage = stories[0].story["hero-image-s3-key"];
  }

  useEffect(() => {
    global.deviceWidth > 1263 && setIsDesktop(!isDesktop);
  }, []);

  return (
    <div styleName={`base ${heroImage ? "" : "no-image"}`}>
      <CustomStoryCard2
        story={firstStory.story}
        imageType="image16x9"
        aspectRatio={[16, 9]}
        isMetaDataShown={true}
        showHeroImage={!!heroImage}
        widths={[300]}
        updatedFont={true}
        src="big-fact"
        updateSubHeadline={true}
        captionStyle={true}
      />
      {!isDesktop && (
        <div styleName="ad-slot">
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="FourteenStories2AdBigFact"
            slotId={adSlotId}
          />
        </div>
      )}
    </div>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  collectionSlug: string,
  publisherAttributes: object,
  adSlotId: string,
};

export default Row1;
